import { gql } from './gql'

/**
 * Get's the string for `cartEmpty` mutation.
 * This mutation clears a cart.
 *
 * Note the hand-written selection set: cinnamon does not reuse
 * `cartFieldsQuery` here, and this is ported as it stands.
 */
export const CART_EMPTY = gql`
  mutation CartEmpty($storefrontName: String!, $sessionUid: ID!) {
    cartEmpty(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      id
      status
      createdAt
      updatedAt
      items {
        sku
        price
        quantity
        name
        description
        packageType
        unitsPerPackage
        unitDivision
        imageURL
        divisionsByUnit
        discount
      }
      groups {
        groupBy
        items {
          sku
          quantity
          price
          name
          imageURL
          minQty
          maxQty
          description
          packageType
          unitsPerPackage
          unitDivision
          divisionsByUnit
          discount
          brand
          customFields
          attributes
          category
        }
        total
      }
    }
  }
`
